export const categories = [
  { slug: 'all', name: '全部', description: '浏览全部漫画作品' },
  { slug: 'lianzai', name: '连载中', description: '正在持续更新的热门连载漫画' },
  { slug: 'wanjie', name: '已完结', description: '完整完结的经典漫画作品' },
  { slug: 'aiqing', name: '恋爱', description: '甜蜜浪漫的恋爱题材漫画' },
  { slug: 'xuanhuan', name: '玄幻', description: '奇幻异世界的玄幻冒险漫画' },
  { slug: 'dushi', name: '都市', description: '现代都市生活情感漫画' },
  { slug: 'kehuan', name: '科幻', description: '未来科技与科幻想象漫画' },
  { slug: 'xuanyi', name: '悬疑', description: '扣人心弦的悬疑推理漫画' },
  { slug: 'guzhuang', name: '古装', description: '古典唯美的古装风情漫画' },
  { slug: 'danmei', name: '耽美', description: '唯美细腻的耽美题材漫画' },
];